// @ts-check
import { StyledHeader, StyledHeaderTitle } from './GitTeamSettings.style';
import { Body1, H3 } from '@linearb/linui-common/typography';
import SelectedInfo from './SelectedInfo';
import { LBButton } from '@linearb/buzz';

const Header = ({
  team,
  selectedReposIds = [],
  selectedServicesIds = [],
  isSelectedOnly,
  setIsSelectedOnly,
  isSaveDisabled,
  onSave
}) => {
  const teamName = team?.name || 'Team';

  return (
    <StyledHeader>
      <StyledHeaderTitle>
        <H3>Associate git data with {teamName}</H3>
        <SelectedInfo
          selectedReposIds={selectedReposIds}
          selectedServicesIds={selectedServicesIds}
          isSelectedOnly={isSelectedOnly}
          setIsSelectedOnly={setIsSelectedOnly}
        />
        <LBButton disabled={isSaveDisabled} onClick={onSave}>
          Save as Team Filter
        </LBButton>
      </StyledHeaderTitle>

      <Body1>
        This selection will filter the data to display only contributions made
        by the {teamName}.<br />
        All metrics will be calculated based on this scope, excluding activity
        from other repositories.
        <br />
        <br />
        These settings will apply to the Home Dashboard, Metrics Dashboard, Git
        Activity, Team Activity, and Team Goals views.
      </Body1>
    </StyledHeader>
  );
};

export default Header;
